"use client";
import Button from "src/app/components/ui/Button";
import { CompanyName } from "../../design1/components/TrustedPartner";
import { useFetchCompanyInfo } from "src/app/lib/fetchCompanyInfo";
import { formatNumber } from "../../design1/components/TrustedPartner";

const Navigate = () => {
  const { data: info } = useFetchCompanyInfo();
  const stats = info?.companyStat;
  const data = [
    {
      header: formatNumber(stats?.total_units_managing || 0),
      subHeader: "Direct Properties",
    },
    {
      header: formatNumber(stats?.total_branch || 0),
      subHeader: "Total Branches",
    },
    {
      header: formatNumber(stats?.total_staff || 0),
      subHeader: "Total Professional Staff",
    },
    {
      header: formatNumber(
        Number(stats?.years_in_industry.match(/\d+/)?.[0]) || 0
      ),
      subHeader: "Years of Experience",
    },
  ];
  return (
    <section className="py-20 xs:pt-0 pb-20">
      <div className="wrapper justify-between flex xlg:flex-col xlg:gap-10 gap-[5%]">
        <div className="first relative basis-1/2">
          <h2 className="mb-12 relative h1 leading-[3.3rem]">
            <span className="max-w-[500px] block">
              Helping You Navigate Every Property Decision
            </span>
            <div className="absolute top-[14%] -left-[calc(7%+18px)]">
              <House />
            </div>
            <div className="absolute right-0 -left-[7%] -bottom-[15%]">
              <SvgLine />
            </div>
          </h2>
          <h3 className="mb-14 h5 !leading-[1.6rem] max-w-[1000px] text-secondary-main">
            {<CompanyName />}! We are excited to offer premium real estate
            services throughout Nigeria. Our platform features exclusive
            listings for over{" "}
            {info?.companyStat?.total_units_managing.toLocaleString()}{" "}
            properties, backed by {stats?.total_branch} branches and a skilled
            team of {stats?.total_staff} real estate professionals. With over{" "}
            {stats?.years_in_industry} {""}
            of industry experience, we specialize in property sales, rentals,
            short lets, and other essential real estate services across the
            nation. Let us be your trusted partner in navigating every step of
            your real estate journey.
          </h3>
          <Button
            href="/about"
            className="!px-8 xlg:hidden primary-btn text-[14px] !py-4"
          >
            Discover More
          </Button>
        </div>

        <div className="flex relative xlg:-bottom-10 gap-6 w-auto h-max">
          <Button
            href="/about"
            className="!px-8 xlg:block xs:!p-[3vw] hidden absolute right-0 bottom-0 primary-btn text-[14px] !py-4"
          >
            Discover More
          </Button>
          <div className="first flex gap-5 flex-col">
            <Card
              className="size-[max(200px,17.32vw)] xlg:size-[max(300px,17.32vw)] xs:!size-[45vw] max-h-[350px] max-w-[350px]"
              {...data[0]}
            />
            <Card
              className="size-[max(200px,17.32vw)] xlg:size-[max(300px,17.32vw)] xs:!size-[45vw] max-h-[350px]  max-w-[350px]"
              {...data[2]}
            />
          </div>
          <div className="second relative top-[-80px] flex gap-5 flex-col">
            <Card
              className="size-[max(160px,13vw)] xlg:size-[max(240px,13vw)]  xs:!size-[35vw] max-h-[280px] max-w-[280px]"
              {...data[1]}
            />
            <Card
              className="size-[max(160px,13vw)] xlg:size-[max(240px,13vw)] xs:!size-[35vw]  max-h-[280px] max-w-[280px]"
              {...data[3]}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
export default Navigate;

const Card: React.FC<{
  header: string;
  subHeader: string;
  className?: string;
}> = ({ header, subHeader, className }) => {
  return (
    <div
      className={`grid rounded-xl border border-themeColor place-items-center ${className}`}
    >
      <div className="items text-themeColor">
        <div className="text-center text-4xl font-semibold">{header}</div>
        <p className="text-center">{subHeader}</p>
      </div>
    </div>
  );
};

const SvgLine = () => {
  return (
    <svg
      width="100%"
      height="54"
      viewBox="0 0 786 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.2"
        d="M1 13H0.5V13.5H1V13ZM34 13H34.5V12.5H34V13ZM34 24H33.5V24.5H34V24ZM45.5 24H46V23.5H45.5V24ZM45.5 33.5H45V34H45.5V33.5ZM61.5 33.5H62V33H61.5V33.5ZM61.5 50.5H61V51H61.5V50.5ZM785.5 50.5L780.5 47.6132V53.3868L785.5 50.5ZM0.5 0.5V13H1.5V0.5H0.5ZM1 13.5H34V12.5H1V13.5ZM33.5 13V24H34.5V13H33.5ZM34 24.5H45.5V23.5H34V24.5ZM45 24V33.5H46V24H45ZM45.5 34H61.5V33H45.5V34ZM61 33.5V50.5H62V33.5H61ZM61.5 51H781V50H61.5V51Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};

const House = () => {
  return (
    <svg
      width="52"
      height="56"
      viewBox="0 0 52 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.2"
        d="M1 30.1453L26.9671 1.7865C27.8155 0.859879 29.2982 0.935867 30.0475 1.94438L51 30.1453M1 30.1453H51M1 30.1453V52.6005C1 53.7051 1.89543 54.6005 3 54.6005H18.0702M51 30.1453V52.6005C51 53.7051 50.1046 54.6005 49 54.6005H35.1404M35.1404 54.6005V47.6416C35.1404 46.5371 34.245 45.6416 33.1404 45.6416H20.259C19.1755 45.6416 18.289 46.5045 18.2598 47.5876L18.0702 54.6005M35.1404 54.6005H18.0702"
        stroke="var(--primary-color)"
        stroke-linecap="round"
      />
    </svg>
  );
};
